(function() {
  'use strict';

  angular
    .module('quiz.labelingPicture')
    .directive('lpImage', LpImage);

  LpImage.$inject = [];

  function LpImage() {
    var directive = {
      scope: {
        lpImage: '<',
        lpImageOndrop: '&'
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attr, ctrl) {
      var image;

      element.droppable({
        accept: '.lp-caption',
        hoverClass: 'active',
        drop: onDrop
      });

      scope.$watch('lpImage', onImage);

      function onDrop(event, ui) {
        scope.$apply(function() {
          var answer = $(ui.helper.context).scope().answer;
          scope.lpImageOndrop({ image: image, answer: answer });
        });
      }

      function onImage(value) {
        image = value;
      }
    }
  }
})();
